import script from "./ContributionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributionView.vue?vue&type=script&setup=true&lang=js"

import "./ContributionView.vue?vue&type=style&index=0&id=cf93acca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf93acca"]])

export default __exports__